/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const noop: () => void = () => undefined;

// Utility function. There is no await by design
// eslint-disable-next-line @typescript-eslint/require-await
export const asyncNoop: () => Promise<void> = async () => noop();

type GetButtonStateProps = {
  isSubmitting: boolean;
  isSubmitSuccessful: boolean;
  isSubmitted: boolean;
};

export function getButtonState({ isSubmitting, isSubmitSuccessful, isSubmitted }: GetButtonStateProps) {
  switch (true) {
    case isSubmitting:
      return "loading";
    case isSubmitSuccessful:
      return "success";
    case isSubmitted && !isSubmitSuccessful:
      return "error";
    default:
      return undefined;
  }
}
